require('./cardSecurePaymentView.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @actions
const cardSecurePaymentActions = require('actions/cardSecurePayment');

// @components
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const { CardSecurePaymentStep1 } = require('components/cards/cardSecurePaymentSteps/cardSecurePaymentStep1/cardSecurePaymentStep1');
const CardSecurePaymentStep2 = require('components/cards/cardSecurePaymentSteps/cardSecurePaymentStep2/cardSecurePaymentStep2');
const CardSecurePaymentSuccessStep = require('components/cards/cardSecurePaymentSteps/cardSecurePaymentSuccessStep/cardSecurePaymentSuccessStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const WebappRender = require('components/conditionalRender/webappRender')

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname')

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const {
    ECOMMERCE_INTERNET_PAYMENTS_ADHERED,
    ECOMMERCE_KEY,
} = require('constants/flagBasedFeatures');

class CardSecurePaymentView extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    componentDidMount() {
        const { history, immCards, getCardSecurePaymentConfiguration, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_SECURE_PAYMENT, { immCard }, history);
        getCardSecurePaymentConfiguration(immCard);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/pago-seguro', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.resetView();
    }

    onCancel() {
        const { history, match: { params: { cardId } } } = this.props;
        history.push(`/myprofile/cards/${cardId}/details`);
    }

    onFinish() {
        const { match: { params: { cardId } }, postChange } = this.props;
        postChange(cardId);
    }

    buildError(immCard) {
        const { immFlagBasedFeatures } = this.props;
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cardSecurePayment-successStepBackToCardLink', [cardAlias]).toUpperCase();
        const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        }

        let errorTitle = formatText('cardSecurePayment-errorTitle');
        let errorMessageText;

        if (immFlagBasedFeatures.get(ECOMMERCE_INTERNET_PAYMENTS_ADHERED) && immFlagBasedFeatures.get(ECOMMERCE_KEY)) {
            errorTitle = formatText('cardSecurePayment-cardSecurePayment_errorTitleCanNotUpdate');
            errorMessageText = (
                <FormattedText
                    avoidTargetBlank={true}
                    value="cardSecurePayment-cardSecurePayment_checkOrModfifyCESAnyTime"
                />
            );
        } else {
            errorMessageText = <FormattedText value="cardSecurePayment-errorMessage" />;
        }

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardError
                    errorMessage={errorTitle}
                    mainButton={goBackButton}>
                    <section className="row card-secure-payment__error">
                        <div className="col-xs-6 col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-7">
                            {errorMessageText}
                        </div>
                    </section>
                </WizardError>
            </div>
        );
    }

    buildSuccessful(immCard, immCardSecurePayment) {
        const { immFlagBasedFeatures } = this.props;
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <CardSecurePaymentSuccessStep
                    immCard={immCard}
                    immCardSecurePayment={immCardSecurePayment}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            </div>
        )
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCardSecurePayment, immFlagBasedFeatures, immProfileFields } = this.props;
        const immSteps = immCardSecurePayment.get('steps');
        const visibleStep = immCardSecurePayment.get('visibleStep');
        const actions = {
            validateStep: this.props.validateStep,
            setWillCancel: this.props.setWillCancel,
            setVisibleStep: this.props.setVisibleStep,
            finish: this.onFinish,
            cancel: this.onCancel
        };
        const immCard = immCards.get('byId').get(cardId);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsPaymentManagementTitle')}
            />
        );
        const phoneNumber = PersonalDataHelper.getPhoneNumber(immProfileFields);

        let block;

        if (immCard) {

            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cards-securePayment'),
                    url: ''
                }
            ];
            let bodyBlock;

            if (immCardSecurePayment.get('submitSuccessful')) {
                bodyBlock = this.buildSuccessful(immCard, immCardSecurePayment);
            } else if (immCardSecurePayment.get('error')) {
                bodyBlock = this.buildError(immCard);
            } else {
                const cardSecurePaymentSidebarClassName = conditionalClassName('hidden-md', 'col-xs-4', 'hidden-xs hidden-sm col-lg-4')

                bodyBlock = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <WebappRender>
                            <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                <CardDetailsSideBar
                                    immCard={immCard}
                                    immCardSecurePayment={immCardSecurePayment}
                                    phoneNumber={phoneNumber}
                                />
                            </div>
                        </WebappRender>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className={'col-lg-8 col-md-12-cc-8'}>
                            <Wizard
                                wizardClass={'my-transfer__wizard'}
                                actions={actions}
                                immSteps={immSteps}
                                stepsAmount={immSteps.size}
                                visibleStep={visibleStep}
                                isFetching={false}
                                showPreLeaveModal={true}>
                                <WizardStep position="first" cancelButton={true}>
                                    <CardSecurePaymentStep1 immCard={immCard} immCardSecurePayment={immCardSecurePayment} />
                                </WizardStep>
                                <WizardStep
                                    addLoadingBehaviour={true}
                                    position="last"
                                    immFinalButton="cardSecurePayment-finalButtonLabel"
                                    cancelButton={true}
                                    isLoading={immCardSecurePayment.get('isFetching')}>
                                    <CardSecurePaymentStep2
                                        immCard={immCard}
                                        immFirstStep={immCardSecurePayment.getIn(['steps', 0])}
                                        immFlagBasedFeatures={immFlagBasedFeatures}
                                    />
                                </WizardStep>
                            </Wizard>
                        </div>
                        {/* >> REF-01 */}
                        <div className={cardSecurePaymentSidebarClassName}>
                            <CardDetailsSideBar
                                immCard={immCard}
                                immCardSecurePayment={immCardSecurePayment}
                                phoneNumber={phoneNumber}
                            />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            const cardSecurePaymentBodyClassName = conditionalClassName('grid-view__body', 'card-secure-payment__body');
            const cardSecurePaymentContainerClassName = conditionalClassName('container-fluid', 'card-secure-payment__container');
            block = (
                <div>
                    <div className="container-fluid card-secure-payment--header-identifier">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('cardSecurePayment-viewTitle')}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={cardSecurePaymentBodyClassName}>
                        <div className={cardSecurePaymentContainerClassName}>
                            <div className="row grid-view--content-position-negative">
                                {bodyBlock}
                            </div>
                        </div>
                    </div>
                </div>
            );

        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardSecurePaymentView.propTypes = {
    getCardSecurePaymentConfiguration: PropTypes.func,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardSecurePayment: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    postChange: PropTypes.func.isRequired,
    resetView: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired
};

module.exports.constructor = CardSecurePaymentView;
module.exports.CardSecurePaymentView = connect(
    state => ({
        immCards: state.cards,
        immCardSecurePayment: state.cardSecurePayment,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immProfileFields: state.profile
    }), {
    getCardSecurePaymentConfiguration: cardSecurePaymentActions.getCardSecurePaymentConfiguration,
    validateStep: cardSecurePaymentActions.validateStep,
    setWillCancel: cardSecurePaymentActions.setWillCancel,
    setVisibleStep: cardSecurePaymentActions.setVisibleStep,
    postChange: cardSecurePaymentActions.postChange,
    resetView: cardSecurePaymentActions.resetView
})(withRouter(CardSecurePaymentView));
